/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client } from './client';

export const getList = () => client.get('paylinks');

// eslint-disable-next-line object-shorthand
export const list = params => client.get('paylinks', { params: params });

export const get = id => client.get(`paylinks/${id}`);

export const getLink = params => client.post('paylinks', params);

// eslint-disable-next-line

// Subscriptions
export const listSubscriptions = params => client.get('payments/subscriptions', { params: params });

export const subscription = id => client.post(`payments/subscription_detail/${id}`);

export const cancelSubscription = id => client.post(`payments/subscription_cancel/${id}`);

// Eletronic Payments
export const listEletronicPayments = params => client.get('celcoins/deposits');
export const eletronicPayment = id => client.get(`celcoins/deposit/${id}`);
export const cancelEletronicPayment = id => client.post(`celcoins/eletronic_payment_cancel/${id}`);
export const newEletronicPayment = params => client.post('celcoins/create_deposit', { deposit: params });
export const location = params => client.post('celcoins/get_location', { location: params });

// Eletronic Receipts
export const listEletronicReceipts = params => client.get('celcoins/receipts');
export const eletronicReceipt = id => client.get(`celcoins/receipt/${id}`);
export const cancelEletronicReceipt = id => client.post(`celcoins/eletronic_receipt_cancel/${id}`);
export const newEletronicReceipt = params => client.post('celcoins/create_receipt', { receipt: params });
